import { defineAsyncComponent } from 'vue'

export default [
  {
    path: '/error-404',
    name: 'error-404',
    component: defineAsyncComponent(() => import('@/views/error/Error404.vue')),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
      public: true,
    },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: defineAsyncComponent(() => import('@/views/authentication/Login-v1.vue')),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
      public: true,
    },
  },
  {
    path: '/Account/:status',
    name: 'login-idc',
    component: defineAsyncComponent(() => import('@/views/authentication/LoginIdc.vue')),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
      public: true,
    },
  },
  {
    path: '/miscellaneous/coming-soon',
    name: 'misc-coming-soon',
    component: defineAsyncComponent(() => import('@/views/miscellaneous/ComingSoon.vue')),
    meta: {
      layout: 'full',
      public: true,
    },
  },
  {
    path: '/not-authorized',
    name: 'misc-not-authorized',
    component: defineAsyncComponent(() => import('@/views/miscellaneous/NotAuthorized.vue')),
    meta: {
      layout: 'full',
      resource: 'Auth',
      public: true,
    },
  },
  {
    path: '/under-maintenance',
    name: 'misc-under-maintenance',
    component: defineAsyncComponent(() => import('@/views/miscellaneous/UnderMaintenance.vue')),
    meta: {
      layout: 'full',
      public: true,
    },
  },
  {
    path: '/error',
    name: 'misc-error',
    component: defineAsyncComponent(() => import('@/views/miscellaneous/Error.vue')),
    meta: {
      layout: 'full',
      public: true,
    },
  },
  {
    path: '/account-setting',
    name: 'pages-account-setting',
    component: defineAsyncComponent(() => import('@/views/account-setting/AccountSettingView.vue')),
    meta: {
      pageTitle: 'Account Settings',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Account Settings',
          active: true,
        },
      ],
    },
  },
]
